(() => {
  const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('nl-NL');

  const initialize = (root) => {
    root.querySelectorAll('[data-bb-pickup-directory]:not([data-ready])').forEach((directory) => {
      directory.dataset.ready = 'true';
      const input = directory.querySelector('[data-bb-pickup-search]');
      const searchWrap = directory.querySelector('[data-bb-pickup-search-wrap]');
      const cards = [...directory.querySelectorAll('[data-bb-pickup-card]')];
      const count = directory.querySelector('[data-bb-pickup-count]');
      const countFallback = directory.querySelector('[data-bb-pickup-count-fallback]');
      const empty = directory.querySelector('[data-bb-pickup-empty]');
      if (!input || !cards.length) return;

      searchWrap.hidden = false;
      if (countFallback) countFallback.hidden = true;
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          searchWrap.classList.toggle('is-visible', entry.isIntersecting);
        }, { threshold: 0.5 });
        observer.observe(searchWrap);
      }
      input.addEventListener('input', () => {
        const query = normalize(input.value.trim());
        let visible = 0;
        cards.forEach((card) => {
          card.hidden = !normalize(card.dataset.search || '').includes(query);
          if (!card.hidden) visible += 1;
        });
        count.textContent = `${visible} ${visible === 1 ? 'ophaallocatie' : 'ophaallocaties'}`;
        empty.hidden = visible !== 0;
        directory.querySelector('bb-card-slider')?.dispatchEvent(new Event('bb:slider:refresh'));
      });
    });
  };

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
